import React from 'react';
import { Button, Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { FaExclamationTriangle } from 'react-icons/fa';

const NotFound = () => {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
      <Card className="text-center border-0 shadow-sm notfound-card">
        <Card.Body className="p-5">
          <div className="display-5 text-danger mb-3">
            <FaExclamationTriangle />
          </div>
          <h1 className="h3 mb-2">404 — Page Not Found</h1>
          <p className="text-muted mb-4">
            The page you’re looking for may have been moved or deleted.
          </p>
          <div className="d-flex gap-2 justify-content-center">
            <Button as={Link} to="/" variant="primary">
              Return to Dashboard
            </Button>
            <Button as={Link} to="/logs" variant="outline-secondary">
              View Logs
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
};

export default NotFound;
